import type { CareTeam, Practitioner, Reference } from '@medplum/fhirtypes'
import { codeableConcept } from '#src/codeableConcept.ts'
import { SDR_TASK_OUTPUT_SYSTEM } from '#src/codeSystems.ts'

export type PractitionerOrCareTeamRef = Reference<CareTeam | Practitioner>

export const SDRStatus = {
  REQUESTED: 'SDR_REQUESTED',
  IN_REVIEW: 'SDR_IN_REVIEW',
  APPROVED: 'SDR_APPROVED',
  DENIED: 'SDR_DENIED',
  PARTIALLY_DENIED: 'SDR_PARTIALLY_DENIED',
  PARTIALLY_APPROVED: 'SDR_PARTIALLY_APPROVED',
  WITHDRAWN: 'SDR_WITHDRAWN',
  IN_APPEAL: 'SDR_IN_APPEAL',
} as const
export type SDRStatus = (typeof SDRStatus)[keyof typeof SDRStatus]

export const sdrStatusToMetadata = {
  [SDRStatus.REQUESTED]: { label: 'Requested' },
  [SDRStatus.IN_REVIEW]: { label: 'In Review' },
  [SDRStatus.APPROVED]: { label: 'Approved' },
  [SDRStatus.DENIED]: { label: 'Denied' },
  [SDRStatus.PARTIALLY_DENIED]: { label: 'Partially Denied' },
  [SDRStatus.PARTIALLY_APPROVED]: { label: 'Partially Approved' },
  [SDRStatus.WITHDRAWN]: { label: 'Withdrawn' },
  [SDRStatus.IN_APPEAL]: { label: 'In Appeal' },
} satisfies Record<
  SDRStatus,
  {
    label: string
  }
>

// TODO: make this a real coding system
export const SDRReviewType = {
  IDTGroupReview: 'IDT Group Review',
  DirectApproval: 'Direct Approval',
} as const
export type SDRReviewType = (typeof SDRReviewType)[keyof typeof SDRReviewType]

export const SDRTaskOutput = {
  NOTIFICATION_ATTEMPT_VERBAL: 'notification-attempt-verbal',
  NOTIFICATION_ATTEMPT_WRITTEN: 'notification-attempt-written',
  DOCUMENT_REFERENCE: 'document-reference',
} as const
export type SDRTaskOutput = (typeof SDRTaskOutput)[keyof typeof SDRTaskOutput]

export const SDR_TASK_OUTPUTS = {
  [SDRTaskOutput.NOTIFICATION_ATTEMPT_VERBAL]: codeableConcept({
    system: SDR_TASK_OUTPUT_SYSTEM,
    code: SDRTaskOutput.NOTIFICATION_ATTEMPT_VERBAL,
    display: 'Notification Attempt (Verbal)',
  }),
  [SDRTaskOutput.NOTIFICATION_ATTEMPT_WRITTEN]: codeableConcept({
    system: SDR_TASK_OUTPUT_SYSTEM,
    code: SDRTaskOutput.NOTIFICATION_ATTEMPT_WRITTEN,
    display: 'Notification Attempt (Written)',
  }),
  [SDRTaskOutput.DOCUMENT_REFERENCE]: codeableConcept({
    system: SDR_TASK_OUTPUT_SYSTEM,
    code: SDRTaskOutput.DOCUMENT_REFERENCE,
    display: 'Document',
  }),
}
